import { Flex, Text } from '@chakra-ui/react';
import CompaniesSettingsService from 'api/services/CompaniesSettingsService';
import CardMy from 'components/CardMy';
import BigTitle from 'components/CardMy/BigTitle';
import InputMy from 'components/InputMy';
import UpdateCancel from 'components/UpdateCancel';
import _ from 'lodash';
import showMessage from 'providers/NoticeProvider/showMessage';
import { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { fetchCallouts, selectCalloutsArray, selectCalloutsIsLoading } from 'store/slices/companySetting';
import { selectMe } from 'store/slices/user';
import Row from './Row';

const Tab3 = () => {
    const dispatch = useAppDispatch();
    const { company } = useAppSelector(selectMe);
    const callouts = useAppSelector(selectCalloutsArray);
    const calloutsIsLoading = useAppSelector(selectCalloutsIsLoading);

    const [loading, setLoading] = useState(false);

    const [data, setData] = useState<Array<{ name: string; value: string }>>(callouts);

    const handleSave = async () => {
        const hasEmpty = !!data.find(item => item.value.trim().length === 0);

        if (hasEmpty) {
            showMessage('You have empty fields', 'error');
            return false;
        }
        try {
            setLoading(true);
            await CompaniesSettingsService.calloutsUpdate({
                companyId: company.id,
                callouts: data.map(item => ({
                    metric: item.name,
                    key: item.value,
                })),
            })
                .then(() => {
                    showMessage('updated');
                    dispatch(fetchCallouts());
                })
                .finally(() => {
                    setLoading(false);
                });
        } catch (error) {}
    };

    const handleCancel = () => setData(callouts);

    const disabled = _.isEqual(callouts, data);

    useEffect(() => {
        if (callouts) {
            setData(callouts);
        }
    }, [calloutsIsLoading]);

    return (
        <CardMy>
            <Flex flexDirection="column" gap="24px">
                <BigTitle>Heading</BigTitle>
                <Flex maxWidth="500px" flexDirection="column" gap="16px">
                    <Row>
                        <Text fontSize="16px" fontWeight={700} color="gray.900">
                            Event
                        </Text>
                        <Text fontSize="16px" fontWeight={700} color="gray.900">
                            Name
                        </Text>
                    </Row>
                    {data.map(item => {
                        return (
                            <Row key={item.name}>
                                <Text fontSize="16px" fontWeight={400} color="gray.900">
                                    {item.name}
                                </Text>
                                <InputMy
                                    value={item.value}
                                    error={item.value.trim().length === 0}
                                    helperText={'this field cannot be empty'}
                                    onChangeValue={value => {
                                        const res = data.map(_item =>
                                            _item.name === item.name ? { ..._item, value } : _item,
                                        );
                                        setData(res);
                                    }}
                                />
                            </Row>
                        );
                    })}
                </Flex>
                <UpdateCancel disabled={disabled} loading={loading} onCancel={handleCancel} onSave={handleSave} />
            </Flex>
        </CardMy>
    );
};
export default Tab3;
